var React = require('react');

function LogoMark (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"fill":"#F4C222","d":"M52.033 104.744a51.896 51.896 0 0028.959-8.797 52.312 52.312 0 0019.213-23.49 52.626 52.626 0 002.989-30.265 52.458 52.458 0 00-14.242-26.83A52.01 52.01 0 0062.28 1.01a51.837 51.837 0 00-30.107 2.97 52.154 52.154 0 00-23.39 19.288A52.57 52.57 0 000 52.372c0 13.88 5.48 27.19 15.236 37.01a51.954 51.954 0 0036.797 15.362z","key":1}),React.createElement("path",{"fill":"#5C5CE5","d":"M115.473 178.888v-62.736l62.403 62.736h-62.403z","key":2}),React.createElement("path",{"fill":"#E54C4C","d":"M177.876 53.477L53.131 178.888H0L177.876.063v53.414z","key":3})]);
}

LogoMark.defaultProps = {"fill":"none","viewBox":"0 0 178 179"};

module.exports = LogoMark;

LogoMark.default = LogoMark;
